/**
 * D229's one-spelling rule for `at_least_of`, as its own leaf (D244 split,
 * from `conditions.ts` at the 500-line cap): the two sugars have their own
 * spellings, and a count the members cannot reach is dead.
 *
 * @packageDocumentation
 */

/**
 * D229: why an `at_least_of` count is refused, if it is — the two sugars
 * have their own spellings, and a count the members cannot reach is dead.
 *
 * @param minimumCount - The count asked for
 * @param memberCount - How many conditions the node holds
 * @returns The complaint, or `undefined` when the count is a genuine "at least k of n"
 */
export const atLeastOfComplaint = (minimumCount: number, memberCount: number): string | undefined => {
	if (minimumCount === 1) {
		return 'at least one of the members is `any_of` — spell it so';
	}

	if (minimumCount === memberCount) {
		return 'at least every member is `all_of` — spell it so';
	}

	return minimumCount > memberCount ? 'minimumCount exceeds the members, so the condition can never hold' : undefined;
};
